export default __webpack_public_path__ + "static/media/MintVideo.3bd02b8b.mp4";